import { render, staticRenderFns } from "./feedback-dashboard.vue?vue&type=template&id=2c4ea11a"
import script from "./feedback-dashboard.vue?vue&type=script&lang=js"
export * from "./feedback-dashboard.vue?vue&type=script&lang=js"
import style0 from "./feedback-dashboard.vue?vue&type=style&index=0&id=2c4ea11a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports